import { Controller } from "@hotwired/stimulus"

// Marks a notification as read on connect. Requires JS execution so
// prefetchers and link scanners don't trigger false reads.
export default class extends Controller {
  static values = { url: String }

  connect() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content || ""

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })
  }
}
